module.exports = "https://cdn.redage.net/src/views/player/documets/images/female.png";